import { Container } from '@/components/base/gridview'
import { classnames } from 'begonya/functions'
import Button from '@/components/base/button'

import { SectionProps } from './types'

const Section: React.FunctionComponent<SectionProps> = (props) => {
  const { anchor, children, container, description, title, ...rest } = props

  return (
    <section {...rest} className={classnames('section', rest.className)}>
      <Container {...container}>
        <header className="section-header">
          {title && (
            <h2
              className="section-header-title"
              dangerouslySetInnerHTML={{ __html: String(title) }}
            />
          )}

          {description && (
            <p
              className="section-header-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {anchor && <Button shape="pill" size="large" anchor={anchor} />}
        </header>
      </Container>
      {children}
    </section>
  )
}

export default Section
